import React from "react"

const ErrorPopUp = (props) => {
  // console.log(props);
  
  if (props.error && props.touched) {
    if (!props.type) {
      return <div className={props.className ? props.className + " required_validator visible" : "required_validator visible"}><div className="validator_container"><span>{'وارد کردن [' + props.error + '] الزامی است'}</span></div></div>;
      }
      else if (props.type === "select") {
        return <div className={props.className ? props.className + " required_validator visible" : "required_validator visible"}><div className="validator_container"><span>{'انتخاب [' + props.error + '] الزامی است'}</span></div></div>;
        }
        else if (props.type === "fullText") {
          return <div className={props.className ? props.className + " required_validator visible" : "required_validator visible"}><div className="validator_container"><span>{ props.error }</span></div></div>;
          }
      }
    if (props.children) {
      return <div className={props.className ? props.className + " required_validator visible" : "required_validator visible"}><div className="validator_container"><span>{'وارد کردن [' + props.children + '] الزامی است'}</span></div></div>
      };
      return '';
    };
export default ErrorPopUp;
